export enum TransactionMethodEnum {
  youkassa = 'youkassa',
  system = 'system',
  manual = 'manual',
}
